import React from "react";

type IconProps = {
    color?: string;
    size?: number | string;
    className?: string;
};

const YouTubeIcon: React.FC<IconProps> = ({
                                              color = "currentColor",
                                              size = 24,
                                              className,
                                          }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={size}
        height={size}
        fill={color}
        className={className}
    >
        <path d="M449.446,0c34.525,0 62.554,28.03 62.554,62.554v386.892c0,34.524 -28.03,62.554 -62.554,62.554H62.554C28.03,512 0,483.97 0,449.446V62.554C0,28.03 28.029,0 62.554,0h386.892Zm-20.967,175.63c-4.139,-15.489 -16.337,-27.687 -31.826,-31.826c-28.078,-7.524 -140.653,-7.524 -140.653,-7.524s-112.575,0 -140.653,7.524c-15.486,4.139 -27.686,16.337 -31.826,31.826c-7.521,28.075 -7.521,86.652 -7.521,86.652s0,58.576 7.521,86.648c4.14,15.489 16.34,27.69 31.826,31.829c28.078,7.521 140.653,7.521 140.653,7.521s112.575,0 140.653,-7.521c15.489,-4.139 27.687,-16.34 31.826,-31.829c7.521,-28.072 7.521,-86.648 7.521,-86.648s0,-58.577 -7.521,-86.652Zm-208.481,140.653v-108.002l93.53,54.001-93.53,54.001Z" />
    </svg>
);

export default YouTubeIcon;
